import React from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardContent,
  Grid as GridBase,
  Typography,
} from "@mui/material";

import LearnMoreButton from "@/components/muiCustom/buttons/LearnMoreButton";

const Grid = GridBase as React.ComponentType<any>;

type EmailCampaignCardProps = {
  campaign: {
    id: string | number;
    name: string;
  };
};

function EmailCampaignCard({ campaign }: EmailCampaignCardProps) {
  return (
    <Card className="email-campaign-card mb-3 card-shadow" elevation={0}>
      <CardContent className="p-3">
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item size={{ lg: 6 }}>
            <Typography variant="body1" className="fw-sb">
              {campaign.name}
            </Typography>
          </Grid>
          <Grid item size={{ lg: 6 }}>
            <Grid
              container
              spacing={2}
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item>
                <Button
                  component={Link}
                  to={`/email-campaigns/join-email-campaign/${campaign.id}`}
                  variant="contained"
                  color="primary"
                  className="fs-11"
                  disableElevation
                >
                  Customize and Schedule
                </Button>
              </Grid>
              <Grid item>
                <LearnMoreButton to={{}} size="large" className="fs-11 py-1" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default EmailCampaignCard;
